import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

// Controlled euro field: shows what the client types, saves cents on blur and re-formats («12.5» -> «12,50»); follows external changes.
export function PriceInput({ cents, onChange, testid }) {
  const [t, setT] = useState(toEuro(cents));
  useEffect(() => { setT(toEuro(cents)); }, [cents]);
  return <Input inputMode="decimal" value={t} placeholder="0,00" onChange={(e) => setT(e.target.value)} data-testid={testid} className="h-10 text-sm"
    onBlur={() => { const c = toCents(t); setT(toEuro(c)); if (c !== cents) onChange(c); }} />;
}

// Controlled multi-line list (one https link per line): edits stay local, the list is saved on blur.
export function LinesInput({ list, onChange, max, testid, placeholder }) {
  const [t, setT] = useState(list.join("\n"));
  useEffect(() => { setT(list.join("\n")); }, [list]);
  return <Textarea rows={3} value={t} placeholder={placeholder} onChange={(e) => setT(e.target.value)} data-testid={testid} className="text-sm"
    onBlur={() => onChange(t.split("\n").map((x) => x.trim()).filter(Boolean).slice(0, max))} />;
}

export const toEuro = (c) => (c == null ? "" : (c / 100).toFixed(2).replace(".", ","));
// «12,50», «1.250,00», «12.50» and «1250» all read as euro; a single dot followed by 1-2 digits is a decimal point
export const toCents = (v) => {
  let s = String(v).trim().replace(/\s|€/g, "");
  if (!s) return null;
  s = s.includes(",") ? s.replace(/\./g, "").replace(",", ".") : /^\d+\.\d{1,2}$/.test(s) ? s : s.replace(/\./g, "");
  const n = Math.round(Number(s) * 100);
  return Number.isFinite(n) && n >= 0 ? n : null;
};
export const DAYS = [["1", "Lunedì"], ["2", "Martedì"], ["3", "Mercoledì"], ["4", "Giovedì"], ["5", "Venerdì"], ["6", "Sabato"], ["0", "Domenica"]];

export function Err({ errs, path }) {
  const m = errs?.[path];
  return m ? <p className="mt-1 text-xs text-rose-600" data-testid={`onb-err-${path.replace(/\./g, "-")}`}>{m}</p> : null;
}

export function Field({ label, path, errs, children, hint }) {
  return (
    <label className="block min-w-0 space-y-1">
      <span className="text-xs font-medium text-slate-700">{label}</span>
      {children}
      {hint && <span className="block text-[11px] text-slate-500">{hint}</span>}
      <Err errs={errs} path={path} />
    </label>);
}

export function Text({ value, onChange, testid, area, ...p }) {
  const C = area ? Textarea : Input;
  const v = value !== undefined ? { value: value ?? "" } : {};  // undefined = uncontrolled (defaultValue + onBlur)
  return <C {...v} onChange={(e) => onChange(e.target.value)} data-testid={testid} className={area ? "text-sm" : "h-10 text-sm"} {...(area ? { rows: 3 } : {})} {...p} />;
}

export function Chip({ on, onClick, children, testid }) {
  return <button type="button" onClick={onClick} aria-pressed={on} data-testid={testid}
    className={`min-h-10 rounded-full border px-3.5 text-sm transition-colors ${on ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-700 hover:border-slate-400"}`}>{children}</button>;
}
